import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';

import { addFix } from '../../utils/strings';
import BasicDataPod from '../BasicDataPod';
import Value from '../BasicDataPod/Value';
import Description from '../BasicDataPod/Description';
import Link from '../BasicDataPod/Link';
import './styles.css';

export default function ToggleDataPod({
  content,
  valueParser = value => value,
  type,
  ...rest
}) {
  const { values, text, linkText, linkUrl, subtitle } = content;
  const [selectedIndex, setSelectedIndex] = useState(0);

  return values.length ? (
    <BasicDataPod {...rest}>
      <div className="togggle-data-pod-content-container">
        <Value value={valueParser(values[selectedIndex].value)} type={type} />
        {subtitle ? (
          <h5 className="toggle-data-pod-subtitle">{subtitle}</h5>
        ) : (
          <div className="toggle-data-pod-subtitle" />
        )}
        <Button.Group className="toggle-data-pod-button-group">
          {values.map((item, index) => (
            <Button
              className={`toggle-data-pod-toggle ${
                index === selectedIndex ? '' : 'toggle-data-pod-toggle-light'
              }`}
              key={item.label}
              size="small"
              color={index === selectedIndex ? 'teal' : undefined}
              toggle
              onClick={(a, data) => setSelectedIndex(index)}
              aria-label={`${item.label}, ${addFix(String(item.value), type)}`}
            >
              {item.label}
            </Button>
          ))}
        </Button.Group>
      </div>
      <Description text={text} />
      <Link linkText={linkText} linkUrl={linkUrl} />
    </BasicDataPod>
  ) : null;
}

ToggleDataPod.propTypes = {
  header: PropTypes.string,
  tooltip: PropTypes.any,
  tooltipHeader: PropTypes.string,
  CustomTooltipIcon: PropTypes.object,
  footer: PropTypes.string,
  isToggle: PropTypes.bool,
  type: PropTypes.oneOf(['currency', 'percent']),
  content: PropTypes.shape({
    values: PropTypes.array,
    text: PropTypes.string,
    linkText: PropTypes.string,
    linkUrl: PropTypes.string,
  }),
};
